export default "__VITE_ASSET__BoE7M_k6__"